export default __webpack_public_path__ + "static/media/020.5bab6f6f.jpg";